import { getDirectusMenu } from '@lucid/utils';
import { graphql, useStaticQuery } from 'gatsby';

import type { Lucid } from 'types/types';

export const useZendeskFooterMenu = (languageKey: Lucid.I18n.LanguagesShortCode) =>
  getDirectusMenu(
    useStaticQuery(graphql`
      query useZendeskFooterMenuQuery {
        directus {
          footer_by_id(id: 2) {
            columns(sort: "order") {
              footer_column_id {
                id
                translations {
                  heading
                  link_set(sort: "order") {
                    menu_link_id {
                      default_link_text
                      final_url
                      beacon_id
                    }
                  }
                  languages_code {
                    short_code
                  }
                }
              }
            }
          }
        }
      }
    `),
    languageKey,
  );
